import { Rule } from "antd/es/form"
import { BuffPlayThemeConfigType } from "../store/types"

export const DATE_RANGE_REGEX = /^\d{2}\/\d{2}-\d{2}\/\d{2}$/

interface DateRangeValidatorOptions {
  themeConfig: BuffPlayThemeConfigType | null
  currentRange?: string | null
  formatMessage?: string
  duplicateMessage?: string
}
interface ParsedRange {
  from: { day: number; month: number }
  to: { day: number; month: number }
}

const parseRange = (range: string): ParsedRange => {
  const [fromStr, toStr] = range.split("-").map(s => s.trim())
  const [fromDay, fromMonth] = fromStr.split("/").map(Number)
  const [toDay, toMonth] = toStr.split("/").map(Number)

  return { from: { day: fromDay, month: fromMonth }, to: { day: toDay, month: toMonth } }
}

const toDate = ({ day, month }: { day: number; month: number }, year: number) => new Date(year, month - 1, day)

const rangesOverlap = (range1: string, range2: string): boolean => {
  const now = new Date().getFullYear()
  const r1 = parseRange(range1)
  const r2 = parseRange(range2)

  const r1Start = toDate(r1.from, now)
  let r1End = toDate(r1.to, now)
  if (r1End < r1Start) r1End = toDate(r1.to, now + 1)

  const r2Start = toDate(r2.from, now)
  let r2End = toDate(r2.to, now)
  if (r2End < r2Start) r2End = toDate(r2.to, now + 1)

  return r1Start <= r2End && r2Start <= r1End
}

export const dateRangeValidator = ({
  themeConfig,
  currentRange,
  formatMessage = "Format must be DD/MM-DD/MM (e.g. 08/12-30/12)",
  duplicateMessage = "This date range already exists",
}: DateRangeValidatorOptions): Rule => ({
  validator: (_, value?: string) => {
    if (!value) {
      return Promise.resolve()
    }

    if (!DATE_RANGE_REGEX.test(value)) {
      return Promise.reject(new Error(formatMessage))
    }

    if (themeConfig) {
      for (const key of Object.keys(themeConfig)) {
        if (key === currentRange) continue

        if (rangesOverlap(value, key)) {
          return Promise.reject(new Error(duplicateMessage))
        }
      }
    }

    return Promise.resolve()
  },
})
